import React from "react";
import { useSearchParams } from "react-router-dom";
import "../assets/css/DigixLeads.css";
import "./aihire/aiHire.css";
import { PreviewBanner } from "./aihire/AiHireUi";
import JobPostingsTab from "./aihire/JobPostingsTab";
import CandidateProfilesTab from "./aihire/CandidateProfilesTab";
import InterviewSchedulerTab from "./aihire/InterviewSchedulerTab";
import FinalizedCandidatesTab from "./aihire/FinalizedCandidatesTab";
import OffersReleasedTab from "./aihire/OffersReleasedTab";

const TABS = [
  { id: "jobs", label: "Job Postings" },
  { id: "candidates", label: "Candidate Profiles" },
  { id: "interviews", label: "Interview Scheduler" },
  { id: "finalized", label: "Finalized Candidates" },
  { id: "offers", label: "Offer Released" },
];

/**
 * Ai Hire (sidebar "HRManagement"): preview of the hiring pipeline with sample data.
 * `?tab=` keeps the open tab; `?job=` filters Candidate Profiles to one job.
 */
function HRManagement() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.id === params.get("tab")) ? params.get("tab") : "jobs";
  const jobId = params.get("job") || "";

  const go = (next, job = "") => {
    const p = { tab: next };
    if (job) p.job = job;
    setParams(p);
  };

  return (
    <div className="digixleads-container hr-management-page aihire-page">
      <div className="main-card">
        <div className="page-header">
          <div className="page-header-row">
            <div className="tabs-container" role="tablist" aria-label="Ai Hire">
              {TABS.map((t) => (
                <button
                  key={t.id}
                  type="button"
                  role="tab"
                  aria-selected={tab === t.id}
                  className={`tab-button ${tab === t.id ? "active" : ""}`}
                  onClick={() => go(t.id)}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <PreviewBanner />
        <div className="aihire-body">
          {tab === "jobs" && <JobPostingsTab onOpenJob={(id) => go("candidates", id)} />}
          {tab === "candidates" && <CandidateProfilesTab jobId={jobId} onJobChange={(id) => go("candidates", id)} />}
          {tab === "interviews" && <InterviewSchedulerTab />}
          {tab === "finalized" && <FinalizedCandidatesTab />}
          {tab === "offers" && <OffersReleasedTab />}
        </div>
      </div>
    </div>
  );
}

export default HRManagement;
